/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SNFSStripeGroup
 */
export interface SNFSStripeGroup {
    /**
     * 
     * @type {string}
     * @memberof SNFSStripeGroup
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SNFSStripeGroup
     */
    statusTags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SNFSStripeGroup
     */
    affinity?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SNFSStripeGroup
     */
    sizeTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof SNFSStripeGroup
     */
    sizeUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof SNFSStripeGroup
     */
    sizeFree?: number;
}

export function SNFSStripeGroupFromJSON(json: any): SNFSStripeGroup {
    return SNFSStripeGroupFromJSONTyped(json, false);
}

export function SNFSStripeGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): SNFSStripeGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'statusTags': json['status_tags'],
        'affinity': !exists(json, 'affinity') ? undefined : json['affinity'],
        'sizeTotal': !exists(json, 'size_total') ? undefined : json['size_total'],
        'sizeUsed': !exists(json, 'size_used') ? undefined : json['size_used'],
        'sizeFree': !exists(json, 'size_free') ? undefined : json['size_free'],
    };
}

export function SNFSStripeGroupToJSON(value?: SNFSStripeGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'status_tags': value.statusTags,
        'affinity': value.affinity,
        'size_total': value.sizeTotal,
        'size_used': value.sizeUsed,
        'size_free': value.sizeFree,
    };
}


